import {
  allocationsAt,
  caseCountOf,
  fteOf,
  loadOf,
  shortOf,
  sum,
  type Case,
  type Staff,
} from '@kdk/shared';

export type CaseMember = {
  staff: Staff;
  percent: number;
  role: string | null;
  /** 本人のその月の総負荷(%) */
  load: number;
  caseCount: number;
};

export type CaseDetail = {
  month: number;
  fte: number;
  headCount: number;
  shortage: number;
  members: CaseMember[];
};

export const buildCaseDetail = (
  caseItem: Case,
  staff: readonly Staff[],
  knownCaseIds: ReadonlySet<string>,
): CaseDetail => {
  const month = caseItem.startMonth;
  const members = staff
    .flatMap((s): CaseMember[] => {
      const mine = allocationsAt(s, month).filter((a) => a.caseId === caseItem.id);
      if (mine.length === 0) return [];
      return [
        {
          staff: s,
          percent: sum(mine.map((a) => a.percent)),
          role: mine[0]?.role ?? null,
          load: loadOf(s, month),
          caseCount: caseCountOf(s, month, knownCaseIds),
        },
      ];
    })
    .sort((x, y) => y.percent - x.percent);
  return {
    month,
    fte: fteOf(staff, caseItem, month),
    headCount: members.length,
    shortage: shortOf(staff, caseItem),
    members,
  };
};
